export default {
  saveCartToStorage (state) {
    const parsed = JSON.stringify(state.cart)
    localStorage.setItem('cart', parsed)
  },
  getCartFromStorage () {
    if (localStorage.getItem('cart')) {
      try {
        const cart = JSON.parse(localStorage.getItem('cart'))
        return cart
      } catch (e) {
        localStorage.removeItem('cart')
        return null
      }
    } else { return null }
  },

  removeCartFromStorage () {
    localStorage.removeItem('cart')
  },

  saveOrderToStorage (order) {
    const parsed = JSON.stringify(order)
    localStorage.setItem('order', parsed)
  },

  getOrderFromStorage () {
    try {
      const order = JSON.parse(localStorage.getItem('order'))
      return order
    } catch (e) {
      return null
    }
  },

  removeOrderFromStorage () {
    localStorage.removeItem('order')
  },

  saveProductsToStorage (products) {
    const parsed = JSON.stringify(products)
    localStorage.setItem('products', parsed)
  },

  getProductsFromStorage () {
    if (localStorage.getItem('products')) {
      try {
        const products = JSON.parse(localStorage.getItem('products'))
        return products
      } catch (e) {
        localStorage.removeItem('products')
        return null
      }
    } else { return null }
  }
}
